import { Reviews } from '../../constants/apis';
import type { FeedbackShare, FeedbackTopicType, RecentReviewInfo, ReviewParent } from '../../types/feedbacks';
import { ApiManager } from '../axios-config';

export const createReview = async (
  topicId: ReviewParent['topicId'],
  topicType: ReviewParent['topicType'],
  content: ReviewParent['content'],
  ranges: FeedbackShare['ranges'],
  mentions: FeedbackShare['mentions'],
  token: string,
  topicSlug: string,
  topicTitle: string,
  score: ReviewParent['score'],
) => {
  return ApiManager.post(
    `${Reviews}`,
    {
      topicId,
      topicTitle,
      topicType,
      topicSlug,
      score,
      ranges,
      mentions,
      ...(content && { content }),
    },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const updateReview = async (
  commentId: ReviewParent['id'],
  content: ReviewParent['content'],
  ranges: FeedbackShare['ranges'],
  mentions: FeedbackShare['mentions'],
  score: ReviewParent['score'],
  token: string,
) => {
  return ApiManager.put(
    `${Reviews}/${commentId}`,
    {
      ranges,
      mentions,
      score,
      ...(content && { content }),
    },
    {
      headers: { Authorization: `Bearer ${token}` },
    },
  );
};

export const trashReview = async (commentId: ReviewParent['id'], token: string) => {
  return ApiManager.put(
    `${Reviews}/trash`,
    { ids: [commentId] },
    { headers: { Authorization: `Bearer ${token}` } },
  );
};

export const recentReviews = async (topicType: FeedbackTopicType, topicId: string) => {
  return ApiManager.get<RecentReviewInfo[]>(`${Reviews}/${topicType}/${topicId}/recent`);
};
